var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{attrs:{"id":"app"}},[_c('div',[_c('nav-view'),_c('hr')],1),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }